<template>
  <div class="row text-center">
    <div class="col-12">
      <section class="recover-password">
        <div class="container">
          <div class="recover-password__group">
            <h1 class="recover-password__title">Recuperar a senha</h1>
            <p class="recover-password__resume">
              Informe-nos o e-mail cadastrado para enviarmos um link de
              recuperação.
            </p>

            <div v-show="alertError" class="alert alert-danger" role="alert">
              Este email não está cadastrado
            </div>

            <form class="recover-password__form">
              <div
                class="form-group"
                :class="{ 'form-group--error': $v.email.$error }"
              >
                <input
                  id="exampleInputEmailOrCpf"
                  v-model="$v.email.$model"
                  type="text"
                  class="form-control"
                  aria-describedby="recoverEmailCPF"
                  placeholder="E-mail"
                />

                <div v-if="$v.email.$error" class="error">
                  <div v-if="!$v.email.required" class="error">
                    Campo obrigatório
                  </div>
                  <div class="error" v-if="!$v.email.email">Email inválido</div>
                </div>
              </div>

              <button
                type="submit"
                class="button3"
                @click.prevent="sendEmail()"
              >
                Enviar link de recuperação
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { authMethods, userMethods, authComputed } from "./../state/helpers";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "RecoverPassword",
  data() {
    return {
      email: ""
    };
  },

  validations: {
    email: {
      required,
      email
    }
  },

  methods: {
    ...authMethods,
    ...userMethods,

    sendEmail() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.forgotPassword({ email: this.email }).then(response => {
          if (response.status == 200) {
            this.$router.push({
              name: "PasswordMessage",
              params: { userEmail: this.email }
            });
          } else if (response.data.status == 404) {
            this.$router.push("RecoverPassword");
          }
        });
      }
    }
  },

  computed: {
    ...authComputed
  }
};
</script>
